import React from 'react';
import {
    ListChecks, Type, AlignLeft, Link2, ArrowUpDown, Calculator
} from 'lucide-react';

export const RESPONSE_TYPES = {
    MULTISELECT: 'multiselect',
    SHORT_ANSWER: 'short_answer',
    CALCULATION: 'calculation',
    PARAGRAPH: 'paragraph',
    MATCHING: 'matching',
    ORDERING: 'ordering'
};

export const RESPONSE_TYPE_CONFIG = {
    [RESPONSE_TYPES.MULTISELECT]: {
        label: 'Multiple Choice',
        description: 'Select correct options',
        icon: 'ListChecks', // We'll handle icons specifically in the component
        color: 'indigo',
        autoGrade: true
    },
    [RESPONSE_TYPES.SHORT_ANSWER]: {
        label: 'Short Answer',
        description: 'Brief text with math support',
        icon: 'Type',
        color: 'emerald',
        autoGrade: true
    },
    [RESPONSE_TYPES.CALCULATION]: {
        label: 'Calculation',
        description: 'Step-by-step working with final answer',
        icon: 'Calculator',
        color: 'cyan',
        autoGrade: false
    },
    [RESPONSE_TYPES.PARAGRAPH]: {
        label: 'Paragraph',
        description: 'Extended written response',
        icon: 'AlignLeft',
        color: 'blue',
        autoGrade: false
    },
    [RESPONSE_TYPES.MATCHING]: {
        label: 'Matching',
        description: 'Match pairs by dragging',
        icon: 'Link2',
        color: 'purple',
        autoGrade: true
    },
    [RESPONSE_TYPES.ORDERING]: {
        label: 'Ordering',
        description: 'Arrange in correct sequence',
        icon: 'ArrowUpDown',
        color: 'amber',
        autoGrade: true
    }
};

const ICON_MAP = {
    ListChecks, Type, AlignLeft, Link2, ArrowUpDown, Calculator
};

export const ResponseTypeSelector = ({ value, onChange, compact = false }) => {
    return (
        <div className={`grid ${compact ? 'grid-cols-5 gap-1' : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2'}`}>
            {Object.entries(RESPONSE_TYPE_CONFIG).map(([type, config]) => {
                const Icon = ICON_MAP[config.icon];
                const isSelected = value === type;

                return (
                    <button
                        key={type}
                        type="button"
                        onClick={() => onChange(type)}
                        className={`${compact ? 'p-2' : 'p-3'} rounded-lg border-2 transition-all flex flex-col items-center gap-1 ${isSelected
                            ? `border-${config.color}-500 bg-${config.color}-500/20 text-white`
                            : 'border-slate-600 bg-slate-800 text-slate-400 hover:border-slate-500 hover:text-slate-200'
                            }`}
                        style={isSelected ? {
                            borderColor: `var(--${config.color}-500, #6366f1)`,
                            backgroundColor: `var(--${config.color}-500, #6366f1)20`
                        } : {}}
                    >
                        <Icon size={compact ? 16 : 20} />
                        <span className={`${compact ? 'text-[10px]' : 'text-xs'} font-medium text-center leading-tight`}>
                            {config.label}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};
